export const SIGNATURE_SUBS = [
  {
    name: "THE OG BOMBAY",
    desc: "One full-length batata vada, dry lasun chutney, teekha green chutney. The icon, uncurled.",
    chota: 79,
    bada: 139,
    img: "/assets/menu-og-bombay.jpg",
    story: "Dadar, 1966. One tapri, one vada, one pav — and a city that never queued quietly again. This is that first bite, just longer.",
  },
  {
    name: "MIRCHI KA BADLA",
    desc: "Mirchi bhaji fritters with kharda thecha. Revenge is best served fried.",
    chota: 89,
    bada: 149,
    tag: "TEEKHA!",
    img: "/assets/menu-mirchi-ka-badla.jpg",
    story: "In Kolhapur they don't say sorry — they serve thecha. Mirchi bhaji was the tapri's answer to a monsoon evening; this is it, weaponised in a loaf.",
  },
  {
    name: "KANDA EXPRESS",
    desc: "Crunchy kanda bhaji stacked end to end, imli drizzle, onion confetti.",
    chota: 89,
    bada: 149,
    img: "/assets/menu-kanda-express.jpg",
    story: "Kanda bhaji is the official snack of every rainy local between Dadar and Dombivli. We stacked it till it reached the last station.",
  },
  {
    name: "CHEESE BARBAAD",
    desc: "Molten Amul cheese avalanche over the long vada. Barbaad in the best way.",
    chota: 109,
    bada: 189,
    img: "/assets/menu-cheese-barbaad.jpg",
    story: "Every Mumbai college canteen has one item that bankrupts your monthly budget. Cheese, meet barbaadi. Zero regrets.",
  },
  {
    name: "SCHEZWAN 65",
    desc: "Long vada slathered in fiery schezwan, crispy onions, mint cool-down.",
    chota: 99,
    bada: 169,
    tag: "TEEKHA!",
    img: "/assets/menu-schezwan-65.jpg",
    story: "Mumbai's favourite Chinese dish was invented in Mumbai, by Mumbai, for Mumbai. Schezwan never saw China. Neither did this sub.",
  },
  {
    name: "PANEER TOOFAN",
    desc: "Charred paneer tikka, mint mayo, pickled onions. A storm in a sub.",
    chota: 129,
    bada: 219,
    img: "/assets/menu-paneer-toofan.jpg",
    story: "Paneer tikka walked into a vada sub and the forecast changed. A toofan from the tandoor, now boarding on platform footlong.",
  },
];

export const BADA_ONLY = {
  name: "TRIDEV",
  desc: "Long vada + mirchi bhaji + kanda bhaji, end to end. Teen legends, ek Bada.",
  price: 179,
  tag: "3x FRY",
  img: "/assets/menu-tridev.jpg",
  story: "Vada. Mirchi. Kanda. The holy trinity of the fryer, finally in one loaf. The Brahma-Vishnu-Mahesh of besan.",
};

export const SIDES = [
  { name: "BAMBAIYA FRIES", desc: "Fries dusted with dry garlic chutney & chaat masala.", price: 69, img: "/assets/menu-fries.jpg", story: "Fries, but they grew up in Byculla — dusted with dry lasun chutney and enough chaat masala to start a conversation." },
  { name: "CUTTING CHAI", desc: "Kadak. Adrak. Half glass, full feeling.", price: 25, img: "/assets/menu-chai.jpg", story: "Half a glass, full conversation. Mumbai's original subscription plan — refilled at every tapri, every hour." },
  { name: "KOKUM COOLER", desc: "Konkan's pink lemonade. Sweet, sour, sorted.", price: 49, img: "/assets/menu-kokum.jpg", story: "Straight off the Konkan coast — the pink that cools whatever the thecha started." },
  { name: "MASALA CHAAS", desc: "Spiced buttermilk. The official fire extinguisher.", price: 39, img: "/assets/menu-chaas.jpg", story: "Your grandmother's fire department, now on tap at the khoka. Curry leaf included, wisdom free." },
];

export const COMBOS = [
  { name: "CHOTA PASS", desc: "OG Bombay Chota + Cutting Chai. Daily commute, sorted.", price: 99 },
  { name: "BADA PASS", desc: "OG Bombay Bada + Bambaiya Fries + Masala Chaas.", price: 219 },
];

export const FORMATS = [
  {
    name: "The Gaadi",
    type: "CART • 25 SQ FT",
    setup: "₹3.5–5 L",
    crew: "2",
    where: "STATIONS, COLLEGE GATES",
    menu: "TOP 4 SUBS + CHAI",
  },
  {
    name: "The Khoka",
    type: "KIOSK • 80–150 SQ FT",
    setup: "₹8–12 L",
    crew: "3",
    where: "HIGH STREETS, METRO",
    menu: "FULL SEVEN + SIDES",
    flagship: true,
  },
  {
    name: "The Adda",
    type: "STORE • 250–400 SQ FT",
    setup: "₹22–30 L",
    crew: "5 + SEATING",
    where: "MALLS, FOOD COURTS",
    menu: "FULL + LIMITED EDITIONS",
  },
];
